<template>
  <!-- NOTE (TEMPLATE) show the universitys -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/universities'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <!-- NOTE (<a>) to add new university -->
      <router-link class="btn btn-success my-2" to="/admin/addUniversity"
        ><strong class="black--text">افزودن دانشگاه جدید +</strong></router-link
      >
      <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 0 1px 15px">
        <v-col>
          <h4 style="margin-top: 9px">دانشگاه‌ها</h4>
        </v-col>
        <v-col>
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            :disabled="isBusy || !items.length"
            @click="$refs.table1.$el.click()"
          >
            <span class="fs-small">
              خروجی اکسل

              <v-icon>$Excel</v-icon></span
            >
          </v-btn>
          <vue-excel-xlsx
            v-show="false"
            ref="table1"
            :data="items"
            :columns="excelFields"
            :filename="'لیست دانشگاه ‌ها'"
            :sheetname="currentDate"
          >
            دریافت اکسل
          </vue-excel-xlsx>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-university) to show the university list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="دانشگاهی ثبت نشده است"
        empty-filtered-text="نتیجه‌ای برای نمایش یافت نشد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(allMehvar)="data">
          <ol>
            <li v-for="mehvar in data.value" :key="mehvar.id">
              <span dir="rtl">{{ mehvar.name }}</span>
            </li>
          </ol>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle">
            <!-- NOTE (<a>) to go to the universitys profile -->
            <v-btn
              :to="'/admin/university/' + data.item.id"
              color="primary"
              style="width: 120px"
              :disabled="data.item.status != 'فعال'"
              >جزییات</v-btn
            ><br />
            <div v-if="role == 'admin'" class="mt-2 mr-2">
              <div v-if="!data.item.busy">
                <b-button
                  class="text-light"
                  variant="danger"
                  @click="activeDeactive(data.item, 'deactive')"
                  v-if="data.item.status == 'فعال'"
                  >غیرفعال کردن</b-button
                >
                <b-button
                  class="text-light"
                  variant="info"
                  @click="activeDeactive(data.item, 'active')"
                  v-else
                  >فعال کردن</b-button
                >
              </div>
              <div class="text-center" v-else>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </div>
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  components: {},
  data() {
    return {
      deletedUniId: "",
      deletedUniName: "",
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "نام دانشگاه" },
        { key: "state", label: "استان" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "id", label: "id" },
        { field: "name", label: "نام دانشگاه" },
        { field: "state", label: "استان" },
      ],
      items: [],
      filter: "",
      isBusy: true,
      deletingUni: false,
      role: window.localStorage.role,
    };
  },
  watch: {
    $route: function () {
      this.onMounted();
    },
  },
  methods: {
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/universities/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.items = res.data;
            this.items.forEach((x) => (x.busy = false));
            this.totalRows = this.items.length;
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    activeDeactive(item, status) {
      let company = item;
      company.busy = true;
      this.reactivity = !this.reactivity;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/university/" + status,
          {
            universityId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          company.busy = false;
          this.reactivity = !this.reactivity;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.onMounted();
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          company.busy = false;
          this.reactivity = !this.reactivity;
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    hideModal(type) {
      // NOTE (modal) to hide modal
      this.$refs[type].hide();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.tdClass {
  min-width: 200px;
}

.table .thead-dark th {
  min-width: 4em;
}

.color {
  background-color: #0c4961;
  color: white;
}
</style>
